import { log } from "@connect/observability";
import type { PresentResult } from "../../../buy-button/wallet";
import type { PaymentSheetProps } from "./buy-flow-screen.types";

const WALLET_NAMES = { apple_pay: "Apple Pay", google_pay: "Google Pay" } as const;

/**
 * Hands an authorized payment to the flow, then closes the wallet's sheet with its outcome:
 * Apple's sheet spins until it is completed. A dismissed sheet leaves the customer on the confirm screen.
 */
export async function settleWalletPayment(
  result: PresentResult,
  tokenProvider: keyof typeof WALLET_NAMES,
  { onSuccess, onError }: Pick<PaymentSheetProps, "onSuccess" | "onError">,
): Promise<void> {
  if (result.status === "dismissed") {
    return;
  }
  if (result.status === "failed") {
    const name = WALLET_NAMES[tokenProvider];
    log.warn(`${name} sheet failed`, { err: String(result.error) });
    onError({ code: "generic", message: `${name} could not start` });
    return;
  }
  const { payment } = result;
  const created = await onSuccess({
    kind: "wallet",
    tokenProvider,
    token: payment.token,
    scheme: payment.scheme,
    billingAddress: payment.billingAddress,
  });
  await payment.complete(created ? "success" : "fail");
}
